export default __webpack_public_path__ + "static/ruce-47b0f21d674ed683ed68a6aa727f9d10.svg";